export default __webpack_public_path__ + "static/media/expoindo-5.98a82f72.jpg";